import { BrowserRouter } from "react-router-dom";
import { AppHelmetProvider } from "@app/providers/HelmetProvider";
import { AuthProvider } from "@app/providers/AuthProvider";
import { AppRouter } from "@app/routes/AppRouter";
import { ErrorBoundary } from "@components/organisms/ErrorBoundary";

export function App() {
  return (
    <ErrorBoundary component="App">
      <AppHelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </AppHelmetProvider>
    </ErrorBoundary>
  );
}
